module.exports = __webpack_public_path__ + "img/jpg.6c24f45d.svg";